import * as React from 'react';
import { Link } from 'react-router-dom';
import Logo from '@/assets/icons/logo.svg?react';
import Telegram from '@/assets/icons/telegram.svg?react';
import Whatsapp from '@/assets/icons/whatsapp.svg?react';
import Phone from '@/assets/icons/phone.svg?react';
import { useAppSelector } from '@/app/store/hooks';
import { selectFooterData } from '@/entities/home_content/model/selectors';
import { contactsType } from '@/entities/home_content/model/types';
import { Typography } from '@/shared/ui/Typography/Typography';

type FooterProps = {
  contacts?: contactsType;
};

export function Footer({ contacts }: FooterProps) {
  const footer_data = useAppSelector(selectFooterData);

  return (
    <section className="w-full border-t-[1px] border-black py-[40px] md:py-[60px]">
      <div className="container flex flex-col gap-[20px] px-[10px] md:gap-[40px] md:px-[32px] 2xl:px-[180px] 3xl:px-[290px]">
        <div className="flex flex-col items-center gap-[20px] md:flex-row md:justify-between">
          <div className="flex flex-col items-center gap-[20px] md:items-start">
            <Logo className="h-[22px] w-[141px]" />

            {contacts && (
              <div className="flex w-full flex-row items-center justify-center gap-[20px]">
                <a
                  href={contacts.telegramUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Telegram className="h-[35px] w-[35px]" />
                </a>
                <a
                  href={contacts.whatsappUrl}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <Whatsapp className="h-[40px] w-[40px]" />
                </a>
                <a href="" target="_blank" rel="noopener noreferrer">
                  <div className="flex h-[36px] w-[36px] items-center justify-center rounded-full border border-black">
                    <Phone className="h-[18px] w-[20px]" />
                  </div>
                </a>
              </div>
            )}
          </div>

          {contacts && (
            <ul className="flex w-full flex-col items-center gap-[20px] md:w-fit md:items-start">
              <li className="normal text-[14px] font-[400]">
                {contacts.address}
              </li>
              <li className="normal text-[14px] font-[400]">
                {contacts.phoneNumbers.join(' ')}
              </li>
              <li className="normal text-[14px] font-[400]">
                {contacts.email}
              </li>
            </ul>
          )}
        </div>

        <div className="w-full rounded-sm border-t-[1px] border-black" />

        {footer_data && (
          <div className="container flex flex-col items-center gap-[20px] md:gap-[40px]">
            <div className="flex flex-wrap justify-center gap-[10px]">
              {footer_data.legal.linksText.map((item, index) => {
                return index == 2 ? (
                  <Link
                    to="/privacy-policy"
                    key={index}
                    className="text-center text-[14px] font-[400] text-[#116ACC]"
                    style={{ lineHeight: '130%' }}
                  >
                    {item.label}
                  </Link>
                ) : (
                  <Typography
                    key={index}
                    className="text-center text-[14px] font-[400]"
                  >
                    {item.label}
                  </Typography>
                );
                // </a>
              })}
            </div>
            <Typography className="text-center text-[14px] font-[300]">
              {footer_data.legal.disclaimer}
            </Typography>
            <Typography className="text-center text-[8px] font-[400]">
              {footer_data.legal.consentNotice}
            </Typography>
          </div>
        )}
      </div>
    </section>
  );
}
